export default __webpack_public_path__ + "static/media/calendar.f534ed6a.svg";